import type { ParticipantRole } from '../store/registrationsSlice'

/** Tailwind classes for each role badge. Used by both the static pill and the select. */
export const ROLE_STYLES: Record<ParticipantRole, string> = {
  Audience: 'bg-pax-blue/10 text-pax-blue',
  Speaker: 'bg-pax-red/10 text-pax-red',
  Staff: 'bg-pax-red/10 text-pax-red',
  Host: 'bg-black text-white',
}
